import React, {useContext, useState, useEffect, useRef} from 'react';
import {Settings} from '../../store';
import useFlyImg from '../../hooks/useFlyImg';
import {gsap} from 'gsap';
import BaseModal from '../general/BaseModal';
import CheckBox from './CheckBox';

const Task = (props) => {

    const {item, type, showContactModal} = props;
    const settingsState = useContext(Settings.State);
    const dispatch = useContext(Settings.Dispatch);
    const [active, setActive] = useState(false);
    const {activeTasks, activeSlide} = settingsState;
    const flyImg = useFlyImg(document.getElementById('swiper-cart'));
    const button = useRef(null);
    const img = useRef(null);
    const [lockClick, setLockClick] = useState(false);
    const [isBaseOpen, setIsBaseOpen] = useState(false);

    const showBaseModal = () => {
        setIsBaseOpen(true);
    };
    const hideBaseModal = () => {
        setIsBaseOpen(false);
    };

    const handleBaseModal = (e) => {
        e.stopPropagation();
        showBaseModal();
    };

    const handleClick = (e) => {
        if (activeSlide === 'summary-block') {
            e.stopPropagation();
            return;
        }
        if (lockClick) {
            e.stopPropagation();
            return;
        }

        if (isBaseOpen) {
            e.stopPropagation();
            return;
        }

        if (type === 'investments') {
            const id = e.target.getAttribute('data-id');
            if (id === 'sustainableShare') {
                dispatch({type: 'setSustainableShare', payload: ''});
            }
            if (id === 'engagement') {
                dispatch({type: 'setEngagement', payload: ''});

            }
            if (id === 'negativeImpact') {
                dispatch({type: 'setNegativeImpact', payload: ''});

            }

            return;
        }


        setActive(!active);
        setLockClick(true);
        let tempObject = activeTasks;

        if (activeTasks.length > 0 && activeTasks.filter(obj => obj.id === item.id).length > 0) {
            tempObject = activeTasks.filter(obj => obj.id !== item.id);
            dispatch({type: 'setActiveTasks', payload: tempObject});
            setLockClick(false);
        } else {
            const imgToFly = img.current;
            const clone = imgToFly.cloneNode();
            button.current.appendChild(clone);
            flyImg(clone, () => {
                setLockClick(false);
                tempObject.push(item);
                dispatch({type: 'setActiveTasks', payload: tempObject});
                gsap.fromTo('#swiper-cart-wrapper', 0.1, {x: -5}, {x: 5, clearProps: 'x', repeat: 1});

            });
        }
    };

    useEffect(() => {
        if (activeTasks.length === 0 || activeTasks.filter(obj => obj.id === item.id).length === 0) {
            setActive(false);
        } else {
            setActive(true);
        }
    }, [activeTasks]);


    let buttonClasses = 'btn btn-task d-flex justify-content-between align-items-center p-3 p-lg-4 w-100';
    if (active) {
        buttonClasses += ' active';
    }

    return (<div className='col'>
                <button onClick={handleClick} data-id={item.id}
                        className={buttonClasses}>
                    <div className="d-flex align-items-center gap-2 gap-lg-3 w-100">
                        <img className="btn-task__icon" src={'./media/icons/' + item.icon} width="32" height="32"
                            alt="icon"/>

                        <span className="" dangerouslySetInnerHTML={{__html:item.content}}></span>
                        <span onClick={handleBaseModal} style={{cursor: 'pointer'}}
                            className={'btn btn--info p-0 ms-auto ms-lg-0 me-2'}>
                                    <svg width="32" height="32" viewBox="0 0 32 32"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_722_2738" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
    <rect width="32" height="32" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_722_2738)">
    <path d="M15.9855 23.4871C16.3662 23.4871 16.6877 23.3557 16.9501 23.0928C17.2125 22.83 17.3437 22.5082 17.3437 22.1275C17.3437 21.7468 17.2123 21.4252 16.9494 21.1628C16.6865 20.9004 16.3647 20.7692 15.984 20.7692C15.6033 20.7692 15.2818 20.9007 15.0194 21.1635C14.757 21.4264 14.6258 21.7482 14.6258 22.1289C14.6258 22.5096 14.7572 22.8312 15.0201 23.0936C15.283 23.356 15.6048 23.4871 15.9855 23.4871ZM15.0412 18.7128H16.9181C16.9352 18.0564 17.0313 17.5321 17.2065 17.1397C17.3817 16.7475 17.8069 16.2274 18.4822 15.5795C19.0685 14.9932 19.5176 14.4517 19.8296 13.9551C20.1416 13.4586 20.2975 12.8721 20.2975 12.1958C20.2975 11.0482 19.8852 10.1518 19.0604 9.50644C18.2356 8.86115 17.26 8.53851 16.1335 8.53851C15.0207 8.53851 14.0997 8.83552 13.3707 9.42954C12.6416 10.0235 12.1215 10.7231 11.8104 11.5282L13.5232 12.2154C13.6856 11.7726 13.9634 11.3415 14.3565 10.9218C14.7497 10.5021 15.3335 10.2923 16.1078 10.2923C16.8959 10.2923 17.4784 10.5081 17.8553 10.9398C18.2322 11.3714 18.4207 11.8462 18.4207 12.3641C18.4207 12.8171 18.2916 13.2316 18.0335 13.6077C17.7754 13.9838 17.4463 14.347 17.0463 14.6975C16.1711 15.4872 15.6181 16.1171 15.3873 16.5872C15.1566 17.0573 15.0412 17.7658 15.0412 18.7128ZM16.0024 28.6666C14.2505 28.6666 12.6037 28.3342 11.0622 27.6693C9.5207 27.0044 8.17979 26.1021 7.0395 24.9623C5.89919 23.8225 4.99644 22.4822 4.33126 20.9413C3.66609 19.4005 3.3335 17.7542 3.3335 16.0022C3.3335 14.2503 3.66594 12.6036 4.33083 11.0621C4.99572 9.52057 5.89805 8.17966 7.03783 7.03937C8.17763 5.89906 9.51795 4.99632 11.0588 4.33114C12.5996 3.66596 14.246 3.33337 15.9979 3.33337C17.7498 3.33337 19.3965 3.66582 20.938 4.33071C22.4796 4.9956 23.8205 5.89793 24.9608 7.03771C26.1011 8.17751 27.0038 9.51783 27.669 11.0587C28.3342 12.5995 28.6668 14.2459 28.6668 15.9978C28.6668 17.7497 28.3343 19.3964 27.6694 20.9379C27.0045 22.4794 26.1022 23.8204 24.9624 24.9606C23.8226 26.101 22.4823 27.0037 20.9415 27.6689C19.4006 28.3341 17.7543 28.6666 16.0024 28.6666ZM16.0001 26.6667C18.9779 26.6667 21.5001 25.6333 23.5668 23.5667C25.6335 21.5 26.6668 18.9778 26.6668 16C26.6668 13.0222 25.6335 10.5 23.5668 8.43334C21.5001 6.36667 18.9779 5.33334 16.0001 5.33334C13.0224 5.33334 10.5001 6.36667 8.43346 8.43334C6.3668 10.5 5.33346 13.0222 5.33346 16C5.33346 18.9778 6.3668 21.5 8.43346 23.5667C10.5001 25.6333 13.0224 26.6667 16.0001 26.6667Z"
        fill="#2F3A71"/>
    </g>
    </svg>


                                                        </span>
                    </div>
                    <img ref={img} width={36}
                        className="cart-img-animation opacity-0 position-absolute" src={'../media/svg/check.svg'}
                        alt=""/>
                    <div className="position-relative zIndex-1 d-flex align-items-center justify-content-center"
                        style={{width: 36, height: 36, minWidth: 36}} ref={button}>
                        <CheckBox active={active}/>

                    </div>
                    <BaseModal showContactModal={showContactModal} content={item.popup} icon={'./media/icons/' + item.icon} title={item.content}
                            isBaseOpen={isBaseOpen} hideBaseModal={hideBaseModal}/>
                </button>
            </div>
    );

};

export default Task;